import React from 'react';
import classnames from 'classnames';
import { useMediaQuery } from 'react-responsive';
import { Typography, TypographyProps } from '@guildeducationinc/recess';
import { MOBILE_QUERY } from '@src/constants';
import './ActionCardContent.scss';

interface ActionCardContentProps {
  estimate?: string;
  estimateAlign?: 'natural' | 'top';
  title: string | React.ReactElement<TypographyProps>;
  list?: string[];
  body?: string;
  testid?: string;
}

export const ActionCardContent: React.FC<ActionCardContentProps> = ({
  title: ActionCardTitle,
  list,
  body,
  estimate,
  estimateAlign = 'natural',
  testid,
}) => {
  const isMobile = useMediaQuery(MOBILE_QUERY);

  const actionCardContentClassNames = classnames('actionCardContent', 'flex--1', 'flexBasis--auto');

  const estimateClassNames = classnames(
    'estimate',
    'padding--bottom_8',
    estimateAlign === 'top' && 'estimateAlign--top'
  );

  const bodyClassNames = classnames('padding--top_8', isMobile && 'padding--bottom_20');

  return (
    <div data-testid={testid} className={actionCardContentClassNames}>
      {estimate && (
        <Typography variant='body1' className={estimateClassNames}>
          {estimate}
        </Typography>
      )}
      {typeof ActionCardTitle === 'string' ? (
        <Typography variant='h3' className='actionCardTitle'>
          {ActionCardTitle}
        </Typography>
      ) : (
        ActionCardTitle
      )}
      {list && (
        <ul className='padding--left_24'>
          {list.map((listItemText) => (
            <li key={listItemText}>{listItemText}</li>
          ))}
        </ul>
      )}
      {body && (
        <Typography variant='body1' className={bodyClassNames}>
          {body}
        </Typography>
      )}
    </div>
  );
};

export default ActionCardContent;
